import { createSentryPiniaPlugin } from '@sentry/vue';
import { pick } from 'lodash';
import { createPinia } from 'pinia';

export default ({ app }) => {
  const pinia = createPinia();
  pinia.use(createSentryPiniaPlugin(
    {
      /**
       * Trims the Pinia store state to avoid exceeding Sentry payload size limits,
       * resulting in an HTTP 413 "Payload Too Large" error.
       */
      stateTransformer: (state) => {
        return {
          auth: pick(state.auth ?? {}, [
            'userDetails',
            'emailVerified',
            'newUserInfo',
            'connectedClinic',
            'currentClient',
            'billing',
          ]),
          network: state.network,
          programs: pick(state.programs ?? {}, [
            'isLoadingPrograms',
            'isLoadingProgramTemplates',
          ]),
          sessions: pick(state.sessions ?? {}, [
            'primaryActiveSession',
            'activeSessionGroup',
            'activeVideoCallSessions',
          ]),
        };
      },
    },
  ));
  app.use(pinia);
};
